import Head from '~/components/Head'
import { Post } from '~/types/post'
import { PostArticle } from '~/types/postArticle'
import { PostImage } from '~/types/postImage'
import { PostLink } from '~/types/postLink'
import { PostText } from '~/types/postText'
import Posts from '~/components/Posts'
import React from 'react'
import { graphql } from 'gatsby'
import moment from 'moment'

type ViewProps = {
    data: {
        allContentfulPostArticle: {
            nodes: PostArticle[]
        }
        allContentfulPostImage: {
            nodes: PostImage[]
        }
        allContentfulPostLink: {
            nodes: PostLink[]
        }
        allContentfulPostText: {
            nodes: PostText[]
        }
    }
}

export default ({ data }: ViewProps) => {
    const posts = data.allContentfulPostArticle.nodes
        .map(x => ({ ...x, type: 'postArticle' } as Post))
        .concat(data.allContentfulPostImage.nodes.map(x => ({ ...x, type: 'postImage' } as Post)))
        .concat(data.allContentfulPostLink.nodes.map(x => ({ ...x, type: 'postLink' } as Post)))
        .concat(data.allContentfulPostText.nodes.map(x => ({ ...x, type: 'postText' } as Post)))
        .sort((a, b) => (moment(a.createdAt).isBefore(moment(b.createdAt)) ? 1 : -1))

    return (
        <div>
            <Head title="All Posts" url="/feed" />
            <Posts posts={posts} />
        </div>
    )
}

export const query = graphql`
    query {
        allContentfulPostArticle {
            nodes {
                ...postArticleFragment
                institution {
                    ...institutionFragment
                }
            }
        }
        allContentfulPostImage {
            nodes {
                ...postImageFragment
                institution {
                    ...institutionFragment
                }
            }
        }
        allContentfulPostLink {
            nodes {
                ...postLinkFragment
                institution {
                    ...institutionFragment
                }
            }
        }
        allContentfulPostText {
            nodes {
                ...postTextFragment
                institution {
                    ...institutionFragment
                }
            }
        }
    }
`
